import { useState, useEffect } from "react";
import { Link } from 'react-router-dom';


function Navbar() {
    const [isHidden, setIsHidden] = useState(false);
    const [lastScroll, setLastScroll] = useState(0);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

            setIsMobileMenuOpen(false);

            if (currentScroll > lastScroll && currentScroll > 50) {
                setIsHidden(true);
            } else {
                setIsHidden(false);
            }
            setLastScroll(currentScroll <= 0 ? 0 : currentScroll);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [lastScroll]);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    return (
        <nav className={`navbar ${isHidden ? 'hidden' : ''}`}>
            <Link to = "/" className="logo">
            Jian Mavrik Design
            </Link>

            <div className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`} onClick={toggleMobileMenu}>
                <span className="bar"></span>
                <span className="bar"></span>
                <span className="bar"></span>
            </div>


            <ul className={`nav-links ${isMobileMenuOpen ? "active" : ""}`}>
                <li>
                    <Link to = "/"onClick={()=> setIsMobileMenuOpen(false)}>Home</Link>
                </li>
                <li>
                    <Link to = "/promotion" onClick={()=> setIsMobileMenuOpen(false)}>Promotion & Deals</Link>
                </li>

                <li className="dropdown">
                    <Link to = "/gallery" className="dropdown-toggle" onClick={()=> setIsMobileMenuOpen(false)}>Gallery</Link>
                </li>

                <li>
                    <Link to = "/service" onClick={()=> setIsMobileMenuOpen(false)}>Service</Link>
                </li>
                <li>
                    <Link to = "/contact" onClick={()=> setIsMobileMenuOpen(false)}>Contact</Link>
                </li>
            </ul>
            
        </nav>
    );
}

export default Navbar;